export default __webpack_public_path__ + "static/media/6.23e83807.png";